import { createAction } from '@reduxjs/toolkit'
import { createPromiseAction } from 'redux-saga-promise-actions'

export const createPickupAuthorization = createAction('pickup/CREATE')
export const createPickupAuthorizationSuccessful = createAction(
  'pickup/CREATE_SUCCESSFUL'
)
export const createPickupAuthorizationFailure = createAction(
  'pickup/CREATE_FAILURE'
)

export const createPickupAuthorizationRSPA = createPromiseAction(
  'rspa: CREATE_PICKUP'
)()
export const editPickupAuthorizationRSPA = createPromiseAction(
  'rspa: EDIT_PICKUP'
)()

export const getPickupAuthorizations = createAction('authorizations/GET')
export const getPickupAuthorizationsSuccessful = createAction(
  'authorizations/GET_SUCCESSFUL'
)
export const getPickupAuthorizationsFailure = createAction(
  'authorizations/GET_FAILURE'
)

export const getAuthorization = createAction('authorizations/GET_BY_ID')
export const getAuthorizationSuccessful = createAction(
  'authorizations/GET_BY_ID_SUCCESSFUL'
)
export const getAuthorizationFailure = createAction(
  'authorizations/GET_BY_ID_FAILURE'
)

export const clearCurrentAuthorization = createAction(
  'authorizations/CLEAR_CURRENT'
)

export const deleteAuthorization = createAction('authorizations/DELETE')
export const deleteAuthorizationSuccessful = createAction(
  'authorizations/DELETE_SUCCESSFUL'
)
export const deleteAuthorizationFailure = createAction(
  'authorizations/DELETE_FAILURE'
)
export const approveTemporaryAuthorizationRSPA = createPromiseAction(
  'rspa: APPROVE_TEMPORARY_AUTHORIZATION'
)()
